import type { Banner } from '../../../model';
export interface BannerResponse {
  banners: Banner[];
}

export interface GetBannersRequest {
  active?: boolean;
  location: string;
  limit?: number;
}
